// @flow
import { componentFactory } from '../component-factory';

const baseStyle = {
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  margin: '0 auto',
  padding: '16px',
  textAlign: 'center',
  maxWidth: '320px',
};

const centeredStyle = {
  ...baseStyle,
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
};

export const Content = componentFactory('div', (props) => props.centered ? centeredStyle : baseStyle);
